import { cn } from '../../lib/cn'

interface LogoProps {
  className?: string
  /** 'full' = mark + wordmark, 'mark' = leaf only */
  variant?: 'full' | 'mark'
  tone?: 'brand' | 'light'
}

/** Recreated brand leaf mark (from the GreenbayBio logo) — recolorable via currentColor. */
export function LeafMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={className} role="presentation" aria-hidden="true" fill="none">
      <path
        d="M52 8C50 30 40 52 20 56c-8 2-14-2-14-2S6 20 30 10c9-4 22-2 22-2Z"
        fill="currentColor"
      />
      <path
        d="M14 52C24 44 34 32 44 16"
        stroke="var(--leaf-vein, #F7F5EF)"
        strokeWidth="3.4"
        strokeLinecap="round"
      />
    </svg>
  )
}

/**
 * Official GreenbayBio logo. Renders the real brand artwork: the green version on light surfaces
 * and a white version on dark surfaces (hero, footer, mobile menu), selected via `tone`.
 * `variant="mark"` falls back to the recolorable leaf glyph for tight/decorative spots.
 */
export function Logo({ className, variant = 'full', tone = 'brand' }: LogoProps) {
  if (variant === 'mark') {
    return <LeafMark className={cn('h-8 w-8', tone === 'light' ? 'text-white' : 'text-brand-500', className)} />
  }

  const src = tone === 'light' ? '/brand/greenbay-logo-white.png' : '/brand/greenbay-logo.png'
  return (
    <img
      src={src}
      alt="Greenbay Biotech International"
      width={1000}
      height={594}
      decoding="async"
      className={cn('h-11 w-auto select-none object-contain', className)}
    />
  )
}
